export default __webpack_public_path__ + "scripts/resource/2274677ced4043521a3044cdeb691dea.svg";